import React, { useState, useEffect } from 'react';
import WaitlistModal from '../WaitlistModal/WaitlistModal';
import './InternationalHero.css';

const InternationalHero = ({ userCountry }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [hasSubmitted, setHasSubmitted] = useState(false);
  const [showTooltip, setShowTooltip] = useState(false);

  // Function to get country display name with proper capitalization
  const getCountryDisplay = country => {
    if (!country || country === 'YOUR COUNTRY') return 'YOUR COUNTRY';

    // Convert to proper case (first letter of each word capitalized)
    return country
      .toLowerCase()
      .split(' ')
      .map(word => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');
  };

  useEffect(() => {
    // Check if user has already submitted (persistent across sessions)
    const hasSubmittedPersistent = localStorage.getItem('waitlist-submitted');
    if (hasSubmittedPersistent === 'true') {
      setHasSubmitted(true);
    }
  }, []);

  const handleWaitlistClick = () => {
    if (!hasSubmitted) {
      setIsModalOpen(true);
    }
  };

  const handleModalClose = () => {
    setIsModalOpen(false);
  };

  const handleModalSubmit = formData => {
    // Mark as submitted (persistent across sessions)
    setHasSubmitted(true);
    setIsModalOpen(false);
  };

  const handleButtonMouseEnter = () => {
    if (hasSubmitted) {
      setShowTooltip(true);
    }
  };

  const handleButtonMouseLeave = () => {
    setShowTooltip(false);
  };

  return (
    <div className="international-hero">
      {/* Main Content */}
      <main className="international-main-content">
        <div className="international-content-left">
          <h1 className="international-headline">
            YOUR CONTENT, YOUR
            <br />
            OPPORTUNITY.
            <br />
            <span className="international-subheadline">
              COMING SOON TO {getCountryDisplay(userCountry)}
            </span>
          </h1>

          <p className="international-description">
            EDC is revolutionizing the creator ecosystem, and{' '}
            {getCountryDisplay(userCountry)} is next in line! We provide a new
            way to monetize your content by giving you access to the brands you
            love. A more authentic, relatable, and rewarding way to earn from
            your Everyday Content.
          </p>

          <div className="international-benefits">
            <div className="international-benefit-item">
              <span className="international-checkmark">✅</span>
              <span>
                Get paid to create the content you already love making.
              </span>
            </div>
            <div className="international-benefit-item">
              <span className="international-checkmark">✅</span>
              <span>
                Work with global + local brands that value your voice.
              </span>
            </div>
            <div className="international-benefit-item">
              <span className="international-checkmark">✅</span>
              <span>Turn Everyday Creativity into real income.</span>
            </div>
            <div className="international-benefit-item">
              <span className="international-checkmark">✅</span>
              <span>
                Get exclusive access as one of the first{' '}
                {getCountryDisplay(userCountry)} creators on EDC.
              </span>
            </div>
          </div>

          <div
            className="button-tooltip-container"
            onMouseEnter={handleButtonMouseEnter}
            onMouseLeave={handleButtonMouseLeave}
          >
            <button
              onClick={handleWaitlistClick}
              className="international-waitlist-button"
              disabled={hasSubmitted}
            >
              JOIN THE WAITLIST
            </button>
            {showTooltip && (
              <div className="custom-tooltip">
                You have already joined the waitlist
              </div>
            )}
          </div>
        </div>

        <div className="international-content-right">
          <div className="international-video-container">
            <img
              src="/UAE_KSA_US_Graphic.gif"
              alt="UAE KSA US Graphic"
              className="international-video-graphic"
            />
          </div>
        </div>
      </main>

      <WaitlistModal
        isOpen={isModalOpen}
        onClose={handleModalClose}
        onSubmit={handleModalSubmit}
      />
    </div>
  );
};

export default InternationalHero;
